export enum ETypCertifikatu {
    S = 'S',
    V = 'V',
    B = 'B',
    BV = 'BV',
    D = 'D',
    O = 'O'
}
